module.exports = __webpack_public_path__ + "img/waso.bd276934.svg";